import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ActivityContainer from 'views/ActivityContainer';
import ActivityPlayButtonOverlay from '../ActivityPlayButtonOverlay/ActivityPlayButtonOverlay';
import { handleRepeatActivity } from 'store/actions/activity';
import { handleSettingChangeSubscription } from 'utils/accessibilityUtils';

const LiteSessionActivity = () => {
  const [showOverlay, setShowOverlay] = useState(true);
  const dispatch = useDispatch();
  const {
    settings: {
      accessibility: {
        audioSettings: { muteSounds }
      }
    }
  } = useSelector(state => state.student || {});

  const onPlayButtonOverlayClick = () => setShowOverlay(() => false);

  useEffect(() => {
    const shouldMute = showOverlay || (!showOverlay && muteSounds);
    handleSettingChangeSubscription('muteSounds', shouldMute);
    if (!showOverlay) dispatch(handleRepeatActivity());
  }, [showOverlay]);

  return (
    <>
      {showOverlay && <ActivityPlayButtonOverlay onOverlayClick={onPlayButtonOverlayClick} />}
      <ActivityContainer />
    </>
  );
};

LiteSessionActivity.propTypes = {
  handleRepeatActivity: PropTypes.func
};

export default LiteSessionActivity;
